import { FC, useState } from 'react';
import { DatePicker } from 'antd';

import CaretBtn from '~src/shared/buttons/caretBtn/CaretBtn';
import SvgIcon from '~src/shared/SvgIcon';

import { ComponentContainer, Container, ResetBtn } from './dateRangeSelector.sc';
import { Moment } from 'moment';
import { RangeValue } from 'rc-picker/lib/interface';
import { RangePickerProps } from 'antd/lib/date-picker';
import { useTranslation } from 'react-i18next';

const { RangePicker } = DatePicker;

type Props = OwnProps & Pick<RangePickerProps, 'value' | 'format'>;
interface OwnProps {
  maxWidth?: string;
  onChange(dates: RangeValue<Moment>): void;
}

const DateRangeSelector: FC<Props> = (props) => {
  const [t] = useTranslation();
  const { maxWidth = '216px', onChange, value, format } = props;

  const placeholder: [string, string] = [t('x.okr.objectives.header.due_date_col'), ''];
  const [isOpen, setIsOpen] = useState(false);

  const isEmpty = (range?: RangeValue<Moment>) => !(range && range.length);

  const onClickReset = () => {
    onChange(null);
  };

  return (
    <ComponentContainer>
      <CaretBtn open={isOpen} size="14px" maxWidth="none" doNotSpinCaretOnClick>
        <Container className={isEmpty(value) ? 'is-empty' : ''} $maxWidth={maxWidth}>
          <RangePicker
            bordered={false}
            format={format}
            className={`date-range-selector ${!value ? 'is-input' : ''}`}
            onChange={onChange}
            placeholder={placeholder}
            size="large"
            onOpenChange={setIsOpen}
            separator="--"
            allowClear={false}
            value={value}
          />
        </Container>
      </CaretBtn>
      {value && (
        <ResetBtn className="reset-btn" onClick={onClickReset}>
          <SvgIcon name="iconCrossInCircle" width={15} />
        </ResetBtn>
      )}
    </ComponentContainer>
  );
};

export default DateRangeSelector;
